import CIDInfo from './CIDInfo';
/**
 * 根据cuepoint 数据创建一组数据，用来提供给外部管理文档、白板生命周期的数据
 *
 * @export
 * @class CIDMaker
 */
export default class CIDMaker {
  constructor() {
    this.map = new Map();
  }

  /**
   * 根据传入的数据 生成一组数据，用来管理容器
   *
   * @param data
   * @returns {[]|Array}
   */
  make(data) {
    this.map.clear();
    if (!data || data.length === 0) {
      return [];
    }

    data.forEach(cue => {
      let temp = cue.content2;

      let content;
      if (typeof temp === 'string') {
        content = JSON.parse(temp);
      } else {
        content = temp;
      }

      if (!this.map.has(content['cid'])) {
        let info = new CIDInfo();
        info.cid = content['cid'];
        this.map.set(info.cid, info);
      }
      try {
        let info = this.map.get(content['cid']);
        info.origin = cue;
        info.create = cue['created_at'];
        info.data = content;
      } catch (error) {
        console.warn('CIDMaker', error);
      }
    });

    // 移除cid为空的数据
    this.map.delete('');

    // 移除容器创建时间与销毁时间小于等于2s的容器（当加载一个不存在的文档时，两者相差1.4s）
    this.map.forEach((value, key) => {
      if (value.destroy - value.create <= 2) {
        this.map.delete(key);
      }
    });

    return Array.from(this.map.values());
  }
}
